import { Form, Formik } from "formik";
import { getQueryParams } from "neetocommons/utils";
import { Button, Input } from "neetoui/formik";
import { assoc } from "ramda";
import { useTranslation, Trans } from "react-i18next";

import { INITIAL_FORM_VALUES, LOGIN_FORM_VALIDATION_SCHEMA } from "./constants";

const SignInForm = ({ handleFormSubmit }) => {
  const { t } = useTranslation();
  const { email = "" } = getQueryParams();

  const emailPrefilledInitialValues = () =>
    assoc("email", email, INITIAL_FORM_VALUES);

  if (Button === undefined) {
    return (
      <Trans
        components={{ code: <code /> }}
        i18nKey="neetoMolecules.login.installNeetoUI"
      />
    );
  }

  return (
    <Formik
      initialValues={emailPrefilledInitialValues()}
      validationSchema={LOGIN_FORM_VALIDATION_SCHEMA}
      onSubmit={handleFormSubmit}
    >
      <Form className="flex w-full flex-col gap-y-6">
        <Input
          required
          data-testid="login-email-text-field"
          label={t("neetoMolecules.login.email")}
          name="email"
          size="large"
        />
        <Input
          required
          data-testid="login-password-text-field"
          label={t("neetoMolecules.login.password")}
          name="password"
          size="large"
          type="password"
        />
        <Button
          fullWidth
          data-testid="login-submit-button"
          label={t("neetoMolecules.login.login")}
          size="large"
          style="secondary"
          type="submit"
        />
      </Form>
    </Formik>
  );
};

export default SignInForm;
